import React from 'react'

const SAS = (
  <div className='md:w-4/5 mx-auto py-10 text-lg'>
    <h1 className='text-2xl font-bold'>Statistical Analysis System (SAS)</h1>
    <div>
      <br />
      <p className='md:px-5 text-gray-500'>
        SAS is a statistical and complex analytics tool developed by the SAS Institute. It is one of
        the oldest data analysis tools mainly built to deal with statistical operations. SAS is
        commonly used by professionals and organizations that heavily rely on advanced
        analytics and complex statistical operations. This reliable commercial software provides
        various statistical libraries and tools that can be used for modeling and organizing the
        given data.
      </p>
      <br />
      <p className='md:px-5'>
        The following are the key features and usage of these data science tools:
      </p>
      <br />
      <div className='md:px-5'>
        <ul className='md:px-10 list-disc pl-5 text-gray-500'>
          <li>
            Easy to learn as it comes with ample tutorials and dedicated technical support.
          </li>
          <br />
          <li>
            Simple GUI that produces powerful reports.
          </li>
          <br />
          <li>
            Carries out the analysis of textual content even with typo identification.
          </li>
          <br />
          <li>
            Provides a well-managed suite of tools dealing with areas such as data mining,
            clinical trial analysis, statistical analysis, business intelligence applications,
            econometrics, and time-series analysis.
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default SAS